// it uses gtm
import { useEffect, useMemo, useRef, useState } from "react"

import { useSignUpModalState } from "@fuse/sharedComponents/globalQuickSignUpModal"

import RecaptchaStateProvider from "../signUp/RecaptchaStateProvider"
import { CoreFastSignupComponent } from "./CoreFastSignupComp"

interface IFastSignUpComponent {
  isOpen: boolean
  setOpenState: (val: boolean) => void
  title: string
  phoneNumberToBePrefilled?: string
  showTitleAsIs?: boolean
  cannotDismissPopup?: boolean
  verifyEmail?: boolean
  onClose?: () => void
}

const FastSignUpComponentWithGTM = ({
  isOpen,
  setOpenState,
  title = 'Join "The coolest pool party"',
  phoneNumberToBePrefilled,
  showTitleAsIs = false,
  cannotDismissPopup = false,
  verifyEmail = false,
  onClose,
}: IFastSignUpComponent) => {
  const [step, setStep] = useState(1)
  const urlRef = useRef(window.location.href)
  const urlMap: Record<number, string> = useMemo(() => {
    return {
      1: "/signup/enter-phone",
      2: "/signup/verify-otp",
      3: "/signup/enter-name",
      4: "/signup/enter-email",
    }
  }, [])

  const { fastSignUpStage } = useSignUpModalState()
  useEffect(() => {
    if (isOpen) {
      const host = window.location.origin

      const newUrl = host + urlMap[step]
      console.log({
        host,
        newUrl,
        mainUrl: urlRef.current,
      })

      if (step === 1) {
        window.history.replaceState({}, "", newUrl)
      } else {
        window.history.pushState({}, "", newUrl)
      }
    } else if (!isOpen || fastSignUpStage === "done") {
      window.history.replaceState({}, "", urlRef.current)
    }
  }, [step, fastSignUpStage, urlMap, isOpen])

  return (
    <RecaptchaStateProvider>
      <CoreFastSignupComponent
        isOpen={isOpen}
        step={step}
        setStep={setStep}
        setOpenState={setOpenState}
        title={title}
        phoneNumberToBePrefilled={phoneNumberToBePrefilled}
        showTitleAsIs={showTitleAsIs}
        cannotDismissPopup={cannotDismissPopup}
        from={"createEvent"}
        verifyEmail={verifyEmail}
        onClose={onClose}
      />
    </RecaptchaStateProvider>
  )
}

export default FastSignUpComponentWithGTM
